// fields/SitemapFields.js
import React from "react";
import { Form, Select, Col, Row } from "antd";
import { COMMON_FIELDS } from "../config/seoConfig";

const SitemapFields = () => {
  return (
    <Row gutter={16}>
      <Col lg={12} md={24} sm={24} xs={24}>
        <Form.Item name="sitemap_priority" label="Sitemap Priority">
          <Select
            placeholder="Select sitemap priority"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {COMMON_FIELDS.SITEMAP_PRIORITY_OPTIONS.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={12} md={24} sm={24} xs={24}>
        <Form.Item name="sitemap_frequency" label="Sitemap Change Frequency">
          <Select
            placeholder="Select update frequency"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {COMMON_FIELDS.SITEMAP_FREQUENCY_OPTIONS.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default SitemapFields;
